import { MAX_EMAIL_INPUT_VALIDATION, MAX_INTEGER, MAX_CHARACTER_INPUT_VALIDATION } from "@/constants/common";
import { validator } from "@/utils/validator";

export const createCompanyUserSchema = validator.object().shape({
  fullName: validator.string().trim().emptyToNull().label("ユーザー名").max(MAX_CHARACTER_INPUT_VALIDATION).required(),
  email: validator
    .string()
    .trim()
    .emptyToNull()
    .email()
    .max(MAX_EMAIL_INPUT_VALIDATION)
    .label("メールアドレス")
    .when("isUser", {
      is: 0, // irohana担当者
      then: (schema) =>
        schema.test(
          "email-domain",
          "「irohana担当者」を選択した場合、メールアドレスは「iro-hana.com」または「hopee.com.vn」のドメインのみ登録可能です。",
          function (value) {
            if (!value) return true;
            const allowedDomains = ["iro-hana.com", "hopee.com.vn"];
            const emailDomain = value.split("@")[1];
            return allowedDomains.includes(emailDomain);
          },
        ),
    })
    .required(),
  isUser: validator.number().isSelection().emptyToNull().limit(MAX_INTEGER).label("所属").required(),
});

export const updateCompanyUserSchema = validator.object().shape({
  fullName: validator.string().trim().emptyToNull().label("ユーザー名").max(MAX_CHARACTER_INPUT_VALIDATION).required(),
  email: validator
    .string()
    .trim()
    .emptyToNull()
    .email()
    .max(MAX_EMAIL_INPUT_VALIDATION)
    .label("メールアドレス")
    .when("isUser", {
      is: 0, // irohana担当者
      then: (schema) =>
        schema.test(
          "email-domain",
          "「irohana担当者」を選択した場合、メールアドレスは「iro-hana.com」または「hopee.com.vn」のドメインのみ登録可能です。",
          function (value) {
            if (!value) return true;
            const allowedDomains = ["iro-hana.com", "hopee.com.vn"];
            const emailDomain = value.split("@")[1];
            return allowedDomains.includes(emailDomain);
          },
        ),
    })
    .required(),
  isUser: validator.number().isSelection().emptyToNull().limit(MAX_INTEGER).label("所属").required(),
  activeStatus: validator.string().trim().isSelection().emptyToNull().label("ステータス").required(),
});

// Deprecated: Use createCompanyUserSchema or updateCompanyUserSchema instead
export const companyUserSchema = updateCompanyUserSchema;
